import React from 'react'

const FeedSquare = () => (
  <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="square">
        <rect className="holder" stroke="#121212" x="0.5" y="0.5" width="19" height="19" rx="2" />
        <rect className="thumb" fill="#121212" x="4" y="4" width="12" height="12" rx="2" />
      </g>
    </g>
  </svg>
)

export default FeedSquare
